import { useLocation, useNavigate } from "react-router-dom";
import StatusContainer from "../../../../components/_utils/CommonStatus/StatusContainer";
import InfoCard from "../../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import TabsWeapperSection from "../../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import { useEffect } from "react";
import { setHideBreadCrumb } from "../../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import { useDispatch } from "react-redux";

export default function PrivateTxnError() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  useEffect(() => {
    console.log(state);
    if (state === null) {
      navigate(
        "/beneficiary_transaction_dashboard/create_beneficiary_transaction_private_transaction",
        {
          replace: true,
        },
      );
    }
  }, []);

  return (
    <StatusContainer
      title={"Oops! File upload failed"}
      subtitle={"An error occurred while the uploading the file."}
      buttonRows={[
        [
          {
            btnText: "Upload new file",
            enabledBgColor: "var(--text-primary)",
            enabledTextColor: "var(--negative-bg)",
            icon: "https://q2pay.in/new_assets/common/view_all/upload.svg",
            handleFunction: () =>
              navigate(
                "/private_transaction_dashboard/create_private_transaction",
              ),
            iconToBeAlign: "left",
            fullWidthRequired: true,
            imgColor: "var(--negative-bg)",
          },
        ],
        [
          {
            btnText: "Go to dashboard",
            enabledBgColor: "var(--negative-bg)",
            enabledTextColor: "var(--text-primary)",
            icon: "https://q2pay.in/new_assets/common/dashboard/dashboard.svg",
            handleFunction: () => navigate("/private_transaction_dashboard"),
            iconToBeAlign: "left",
            fullWidthRequired: true,
            outLineColor: "var(--text-primary)",
          },
        ],
      ]}
      status="error"
    >
      <TabsWeapperSection title={"Error details"}>
        <InfoCard
          bgColor="var(--negative-card)"
          rows={[
            {
              leftTitle: state?.message ?? "No file",
              leftSubTitle: "Error message",
            },
          ]}
        />
      </TabsWeapperSection>
    </StatusContainer>
  );
}
